import navBarHomepage from '../modules/navbar-homepage';
import videoPlayer from '../modules/jwplayer-homepage';
import config from '../config';
// import { pollManager } from '../modules/collection_poll';
import storyBandBuilder from '../modules/story-band';
import fetchTilesFeaturedSeries from '../modules/fetchTilesFeaturedSeries';
import newsletterSignup from '../modules/newsletter_signup';

let indexController = () => {
    const localNewsletterSignup = newsletterSignup('.js-newsletter-form');
    localNewsletterSignup.init();
    videoPlayer.on();
    // require('../modules/inline-autoplay-video')();
    // require('../modules/inline-slideshow')();
    // require('../modules/article-video')();
    // require('../modules/floating-images')();
    // require('../modules/pie-chart-data')();
    // require('../modules/scrollback')();
    if (config.get('featureFlags.storyBand') === true) {
        storyBandBuilder.init();
    }
    navBarHomepage.on();
    if (config.get('featureFlags.pollsEnabled') === true) {
        pollManager().init();
    }
    fetchTilesFeaturedSeries();
};

export default indexController;
